import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { atom, useAtomValue } from 'jotai';
import { ReactNode } from 'react';
import { useCopyToClipboard } from 'react-use';

import { FormattedMessage } from '@flipster/i18n';
import { snackbar } from '@flipster/react/design-system/snackbar';

import { webviewInfoBunja } from '.';

export type CopyFn = (value: string) => void;

export function useCopy(successMessage?: ReactNode): CopyFn {
  const [, copyToClipboard] = useCopyToClipboard();
  const { shouldHideSnackbarAtom } = useBunja(copyBunja);
  const shouldHideSnackbar = useAtomValue(shouldHideSnackbarAtom);
  const message = successMessage || <FormattedMessage id='Autogen_common.r251126.s_Copied_to_clipboard' />;

  return function copy(value) {
    copyToClipboard(value);
    if (shouldHideSnackbar) return;
    snackbar.success({ message });
  };
}

const copyBunja = bunja(() => {
  const { webviewInfoAtom } = bunja.use(webviewInfoBunja);

  // jira: https://prex.atlassian.net/browse/QA-13786
  // slack: https://prextech.slack.com/archives/C073YCY3708/p1754013010825349
  const shouldHideSnackbarAtom = atom((get) => {
    const { osType, osVersion } = get(webviewInfoAtom);
    return osType === 'Android' && osVersion >= 33;
  });

  return { shouldHideSnackbarAtom };
});
copyBunja.debugLabel = 'copyBunja';
